export default __webpack_public_path__ + "static/media/reg_3.aa5f9da8.webp";